var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      !_vm.loading
        ? _c(
            "v-card",
            {
              staticClass: "rounded-lg mt-8",
              staticStyle: { margin: "auto" },
              attrs: { "max-width": "700" },
            },
            [
              _c("v-card-title", [_vm._v("Accept Invitation")]),
              _c(
                "v-card-text",
                [
                  _vm.show == "invitation"
                    ? [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.invitation.user_name) +
                              " has invited you to have access to their meeting room."
                          ),
                        ]),
                        _c("div", { staticClass: "font-weight-bold mt-8" }, [
                          _vm._v("Meeting Room Permissions"),
                        ]),
                        _c("v-simple-table", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function () {
                                  return [
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", { staticClass: "text-left" }, [
                                          _vm._v(" Room Name "),
                                        ]),
                                        _c(
                                          "th",
                                          { staticClass: "text-center" },
                                          [
                                            _vm._v(" Coach "),
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  top: "",
                                                  "max-width": "300",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-icon",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey",
                                                                    small: "",
                                                                  },
                                                                },
                                                                "v-icon",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                " mdi-information-outline "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  1574221896
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Coaches can join meetings but can only be seen and heard by other coaches and hosts. Coaches are not seen or heard by guests in the meeting. Once permission is granted, they can enter any meeting at anytime in the specified room."
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "th",
                                          { staticClass: "text-center" },
                                          [
                                            _vm._v(" QA (Quality Assurance) "),
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  top: "",
                                                  "max-width": "300",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-icon",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey",
                                                                    small: "",
                                                                  },
                                                                },
                                                                "v-icon",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                " mdi-information-outline "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  1574221896
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "QAs can quietly log into meetings without being seen or heard by anyone - good for supervisors or those in training. Once permission is granted, they can enter any meeting at anytime in the specified room."
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "th",
                                          { staticClass: "text-center" },
                                          [
                                            _vm._v(" Reports "),
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  top: "",
                                                  "max-width": "300",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-icon",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey",
                                                                    small: "",
                                                                  },
                                                                },
                                                                "v-icon",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                " mdi-information-outline "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  1574221896
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Grants access to room activity reports."
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]),
                                    _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.invitation.room_settings,
                                        function (room) {
                                          return _c(
                                            "tr",
                                            { key: room.ID },
                                            [
                                              room.can_coach || room.can_qa
                                                ? [
                                                    _c("td", [
                                                      _vm._v(_vm._s(room.name)),
                                                    ]),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                      },
                                                      [
                                                        room.can_coach
                                                          ? _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "success",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-check-circle"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                      },
                                                      [
                                                        room.can_qa
                                                          ? _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "success",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-check-circle"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                      },
                                                      [
                                                        room.can_access_reports
                                                          ? _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "success",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-check-circle"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1261350135
                          ),
                        }),
                      ]
                    : _vm._e(),
                  _vm.show == "register"
                    ? [
                        _c(
                          "v-form",
                          {
                            ref: "register_form",
                            attrs: { "lazy-validation": "" },
                            model: {
                              value: _vm.register_valid,
                              callback: function ($$v) {
                                _vm.register_valid = $$v
                              },
                              expression: "register_valid",
                            },
                          },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: "First Name",
                                outlined: "",
                                rules: [_vm.rules.required],
                              },
                              model: {
                                value: _vm.invitation.first_name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.invitation, "first_name", $$v)
                                },
                                expression: "invitation.first_name",
                              },
                            }),
                            _c("v-text-field", {
                              attrs: {
                                label: "Last Name",
                                outlined: "",
                                rules: [_vm.rules.required],
                              },
                              model: {
                                value: _vm.invitation.last_name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.invitation, "last_name", $$v)
                                },
                                expression: "invitation.last_name",
                              },
                            }),
                            _c("v-text-field", {
                              attrs: {
                                label: "Email",
                                outlined: "",
                                rules: [_vm.rules.required, _vm.rules.email],
                              },
                              model: {
                                value: _vm.invitation.email,
                                callback: function ($$v) {
                                  _vm.$set(_vm.invitation, "email", $$v)
                                },
                                expression: "invitation.email",
                              },
                            }),
                            _c("v-text-field", {
                              attrs: {
                                label: "Password",
                                outlined: "",
                                type: "password",
                                rules: [_vm.rules.required, _vm.rules.password],
                              },
                              model: {
                                value: _vm.password,
                                callback: function ($$v) {
                                  _vm.password = $$v
                                },
                                expression: "password",
                              },
                            }),
                            _c("v-text-field", {
                              attrs: {
                                label: "Confirm Password",
                                outlined: "",
                                type: "password",
                                rules: [
                                  _vm.rules.required,
                                  _vm.rules.password,
                                  _vm.rules.password2,
                                ],
                              },
                              model: {
                                value: _vm.password2,
                                callback: function ($$v) {
                                  _vm.password2 = $$v
                                },
                                expression: "password2",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm.show == "login"
                    ? [
                        _c("v-text-field", {
                          attrs: { label: "email", outlined: "" },
                          model: {
                            value: _vm.user_login,
                            callback: function ($$v) {
                              _vm.user_login = $$v
                            },
                            expression: "user_login",
                          },
                        }),
                        _c("v-text-field", {
                          attrs: {
                            label: "password",
                            outlined: "",
                            type: "password",
                          },
                          model: {
                            value: _vm.user_pass,
                            callback: function ($$v) {
                              _vm.user_pass = $$v
                            },
                            expression: "user_pass",
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "v-card-actions",
                { staticClass: "pa-4" },
                [
                  _vm.show == "invitation"
                    ? [
                        !_vm.user.userdata.ID
                          ? [
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.continueBtn()
                                    },
                                  },
                                },
                                [_vm._v("Continue")]
                              ),
                            ]
                          : [
                              _c(
                                "div",
                                {
                                  staticClass: "text--disabled",
                                  staticStyle: { "font-size": ".7em" },
                                },
                                [
                                  _vm._v(
                                    "Logged in as " +
                                      _vm._s(
                                        _vm.user.userdata &&
                                          _vm.user.userdata.data
                                          ? _vm.user.userdata.data.display_name
                                          : ""
                                      )
                                  ),
                                ]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ml-2",
                                  attrs: { "x-small": "", text: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.app.logOut()
                                    },
                                  },
                                },
                                [_vm._v("Log Out")]
                              ),
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    loading: _vm.accepting,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.accept()
                                    },
                                  },
                                },
                                [_vm._v("Accept")]
                              ),
                            ],
                      ]
                    : _vm._e(),
                  _vm.show == "register"
                    ? [
                        _vm._v(" Already have an account? "),
                        _c(
                          "v-btn",
                          {
                            attrs: { text: "", color: "primary" },
                            on: {
                              click: function ($event) {
                                _vm.show = "login"
                              },
                            },
                          },
                          [_vm._v("Log In")]
                        ),
                        _c("v-spacer"),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "primary",
                              loading: _vm.registering,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.register()
                              },
                            },
                          },
                          [_vm._v("Register")]
                        ),
                      ]
                    : _vm._e(),
                  _vm.show == "login"
                    ? [
                        _c(
                          "v-btn",
                          {
                            attrs: { text: "" },
                            on: {
                              click: function ($event) {
                                _vm.show = "register"
                              },
                            },
                          },
                          [_vm._v("Register")]
                        ),
                        _c("v-spacer"),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "primary",
                              loading: _vm.logging_in,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.login()
                              },
                            },
                          },
                          [_vm._v("Log In")]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.loading
        ? _c(
            "v-overlay",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "100", color: "primary" },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }